import { Component } from '@angular/core';
import { header } from './config/surgeries-idika.config';
import { SurgeryIdikaService } from '../../services/surgery-idika/surgery-idika.service';

@Component({
  selector: 'app-surgeries-idika',
  templateUrl: './surgeries-idika.component.html',
  styleUrl: './surgeries-idika.component.scss'
})
export class SurgeriesIdikaComponent {
  constructor(private surgeryIdikaService: SurgeryIdikaService) {}

  ngOnInit() {
    this.surgeryIdikaService.init();
  }

  getPageHeader(): string {
    return header;
  }
}
